import { createContext, useContext } from 'react'
import type { VariablesServer } from '~/config/variables.server'

export type PublicEnv = Pick<
  VariablesServer,
  | 'ENVIRONMENT_NAME'
  | 'NODE_ENV'
  | 'SENTRY_DSN'
  | 'SENTRY_ENVIRONMENT'
  | 'SENTRY_RELEASE'
  | 'DEACTIVATED_FEATURES'
  | 'GOOGLE_TAG_MANAGER_ID'
  | 'STORYBLOK_PREVIEW_URL'
  | 'RECAPTCHA_SITE_KEY'
>

export const EnvContext = createContext<PublicEnv>({
  ENVIRONMENT_NAME: undefined,
  NODE_ENV: '',
  SENTRY_DSN: '',
  SENTRY_ENVIRONMENT: '',
  SENTRY_RELEASE: '',
  DEACTIVATED_FEATURES: [],
  GOOGLE_TAG_MANAGER_ID: '',
  STORYBLOK_PREVIEW_URL: '',
  RECAPTCHA_SITE_KEY: '',
})

export const useEnv = () => useContext(EnvContext)
